import { Pagination } from '@shared/interfacres/request-related';

export interface UsersWithPagination {
  data: User[];
  pagination: Pagination;
}

export enum UserRole {
  Authenticated = 'authenticated',
  Admin = 'admin'
}

export interface Session {
  accessToken: string;
  expiresAt: number;
  refreshToken: string;
}

export interface LoginResponse {
  session: {
    access_token: string;
    expires_at: number;
    // expires_in
    refresh_token: string;
    // token_type
    user: {
      email: string;
      id: string;
      role: UserRole,
      user_metadata: {
        email: string;
        email_verified: boolean;
        first_name: string;
        last_name: string;
        phone_verified: boolean;
        role: string; // 'user' | 'admin'
        stage_name: string;
        sub: string;
      }
    }
  }
}
export interface SubscriptionPlan {
  id: string;
  price: number;
  interval_count: number;
  interval: string;
  monthly: number;
  saveString: string;
  product: {
    id: string;
    name: string;
  }
}

export interface LoggedUser extends Partial<User> {
  role: UserRole;
}

export interface UserProfileResponse {
  id: string;
  firstName: string;
  lastName: string;
  stageName: string;
  performanceType: string[];
  email: string;
  performanceLocations: string[],
  weeklyPerformances: number;
  subscriptionStatus: null | string;
  socialLinks: {
    website?: string;
    facebook?: string;
    instagram?: string;
  }
  createdAt: Date;
  updatedAt: Date;
  role?: string;
}

export interface User {
  subscriptionStatus: null | string;
  isApproved: boolean;
  isRejected: boolean;
  id: string;
  firstName: string,
  lastName: string;
  stageName: string;
  // performanceType: string;
  performanceType: string[];
  email: string;
  performanceLocations: string[];
  weeklyPerformances: number;
  socialLinks: {
    website: string;
    instagram: string;
    facebook: string;
    // twitter: string
  };
  // addressDetails: {
  //   suiteApt: string;
  //   country: string;
  //   state: string;
  //   city: string;
  //   zipCode: string;
  // };
  createdAt: Date;
  updatedAt: Date;
}
//
// export interface CountyItem {
//   name: string;
//   code: string;
//   emoji: string;
//   unicode: string;
//   image: string;
//   dial_code: string;
// }

export interface CreateUserPayload {
  firstName: string;
  lastName: string;
  stageName: string;
  performanceType: string[];
  email: string;
  password: string;

  // promoCode: string;
  // productId: string;
  performanceLocations: string[];
  weeklyPerformances: number;
  socialLinks: {
    website: string;
    instagram: string;
    facebook: string;
  }
}

export interface BillingHistoryItem {
  amountDollars: number;
  created: Date;
  currency: string;
  description: string;
  hostedInvoiceUrl: string;
  id: string;
  invoicePdf: string;
  periodEnd: string;
  periodStart: string;
  status: string;
}
